export default __webpack_public_path__ + "static/media/tutorial1-1.e0e59ca2.png";